import { createVanIconComponent } from "./van"

const Arrow = createVanIconComponent("arrow")
export default Arrow
